import type { Registration } from '@/models'
import { registrationFormErrorMessages } from '@/models'
import { RegistrationCard } from '#components'

export const useRegistrationStore = defineStore('registration.store', () => {
  /**
   * UTILS
   */
  const nuxt = useNuxtApp()
  const layoutStore = useLayoutStore()
  const modalStore = useModalStore()

  const errors = reactive({
    email: '',
    password: '',
    passwordConfirmation: '',
  })

  const generalErrors = ref<any[]>([])

  const isErrorsExists = computed(() => {
    return !!(
      errors.email ||
      errors.password ||
      errors.passwordConfirmation ||
      (generalErrors.value && generalErrors.value.length)
    )
  })

  /**
   * REGISTRATION
   * @param data
   */
  const registration = async (data: Registration) => {
    try {
      await nuxt.$api.resources.registration.post(data)

      clearInvalidFields()
    } catch (error: any) {
      parseError(error.httpStatus, error)
    }
  }

  const parseError = (httpErrorCode: number, error: any) => {
    if (httpErrorCode === 400) {
      const { invalidFields } = error.error.response.data

      if (invalidFields) {
        parseInvalidFields(invalidFields)
      }

      if (!invalidFields) {
        layoutStore.setGlobalError(true)
        generalErrors.value.push(StringifyError(error))
      }
    } else {
      generalErrors.value.push(StringifyError(error))
    }
  }

  const parseInvalidFields = (invalidFields: (keyof Registration)[]) => {
    invalidFields.forEach((invalidField) => {
      if (!Object.keys(errors).includes(invalidField)) {
        layoutStore.setGlobalError(true)
      } else {
        errors[invalidField] =
          registrationFormErrorMessages[invalidField].default
      }
    })
  }

  const clearInvalidFieldError = (invalidField: keyof Registration) => {
    errors[invalidField] = ''
  }

  const clearInvalidFields = () => {
    const invalidFields = Object.keys(errors) as (keyof Registration)[]

    invalidFields.forEach((invalidField) => {
      errors[invalidField] = ''
    })
  }

  const openRegistrationModal = (hideOAuth = false) => {
    modalStore.showModal({
      key: 'registrationModal',
      modalConfig: {
        component: RegistrationCard,
        isModalCloseButtonShown: true,
        modalSize: useDevice().isMobile ? 'bottom' : 'medium',
        showOverlay: true,
        modalComponentProps: {
          hideOAuth,
        },
      },
    })
  }

  return {
    errors,
    generalErrors,
    isErrorsExists,
    registration,
    openRegistrationModal,
    clearInvalidFieldError,
    clearInvalidFields,
  }
})
